export const ADVANCED_TABS_SINGLE_PROP = {
  TITLE: "title",
  ICON: "icon",
};
